import { Maybe } from "graphql/jsutils/Maybe";
import {isNonNullable} from "./is-non-nullable";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Array<T> {
    filterPresent: <S>(this: (Maybe<S> | undefined)[]) => S[];

    groupBy: <K>(keySelector: (value: T) => K) => Map<K, T[]>;

    groupByTransforming: <K, V>(
      keySelector: (value: T) => K,
      valueTransform: (value: T) => V
    ) => Map<K, V[]>;
  }
}

Array.prototype.filterPresent = function <S>(this: S[]): NonNullable<S>[] {
  return this.filter(isNonNullable);
};

Array.prototype.groupBy = function <T, K>(
  this: T[],
  keySelector: (value: T) => K
): Map<K, T[]> {
  const map: Map<K, T[]> = new Map();
  this.forEach((value: T) => {
    const key: K = keySelector(value);
    const existingGrouping: T[] | undefined = map.get(key);
    if (existingGrouping === undefined) {
      map.set(key, [value]);
    } else {
      existingGrouping.push(value);
    }
  });
  return map;
};

Array.prototype.groupByTransforming = function <T, K, V>(
  this: T[],
  keySelector: (value: T) => K,
  valueTransform: (value: T) => V
): Map<K, V[]> {
  const map: Map<K, V[]> = new Map();
  this.forEach((value: T) => {
    const key: K = keySelector(value);
    const existingGrouping: V[] | undefined = map.get(key);
    if (existingGrouping === undefined) {
      map.set(key, [valueTransform(value)]);
    } else {
      existingGrouping.push(valueTransform(value));
    }
  });
  return map;
};

export {};
